import * as React from 'react';
import { createRoot } from 'react-dom/client';
import ReactSelect from 'react-select';

const $ = jQuery;

function Bellow({ career, expandedBellow, handleExpandedBellowChange }) {
    const controlId = `control-${career.ID}`
    const labelId = `label-${career.ID}`
    const isExpanded = expandedBellow === career.ID;

    const blockClass = isExpanded ? 'block-bellow block-bellow--expanded' : 'block-bellow';

    const handleOnClick = (e) => {
        handleExpandedBellowChange( e, career.ID )
    }


    return (
        <div className={ blockClass }>
            <div className="container">
                <div className="block-bellow__top"
                    role="button"
                    aria-expanded={ isExpanded }
                    aria-controls={ controlId }
                    id={ labelId }
                    onClick={ (e) => handleOnClick(e) }
                >
                    {!!career.icon && (
                        <div className="block-bellow__icon" dangerouslySetInnerHTML={{ __html: career.icon }} />
                    )}

                    <div className="block-bellow__top-text">
                        <h3 className="block-bellow__title">
                            {career.post_title} 
                            {!!career.locations.length && (
                                <span className="block-bellow__title-location">{career.locations[0].name}</span> 
                            )}
                        </h3>
                        <div className="block-bellow__description">{career.subtitle}</div>
                    </div>

                    <div className="block-bellow__control"></div>
                </div>

                <div
                    className="block-bellow__collapsable"
                    role="region"
                    id={ controlId }
                    aria-labelledby={ labelId }
                    style={{ display: 'none' }}
                >
                    <div className="block-bellow__content cms">
                        <div dangerouslySetInnerHTML={{ __html: career.short_description }} />
                        <a href={ career.permalink } className="btn-primary">Learn More</a>
                    </div>
                </div>
            </div>
        </div>
    )
}

function CareersList({ careers, locations }) {
    const [selectedTerm, setSelectedTerm] = React.useState(null);
    const [expandedBellow, setExpandedBellow] = React.useState(false);

    let options = locations.map((term) => {
        return {
            label: term.name,
            value: term.term_id,
        }
    })
    
    options = [
        { label: 'All Locations', value: '' },
        ...options
    ];

    const handleOnFilterChange = ( option ) => {
        setSelectedTerm( option.value )
        setExpandedBellow( false )

        // Collapse other accordions
        const expandedBellow = document.querySelector('.careers-list .block-bellow--expanded .block-bellow__collapsable');
        if ( null !== expandedBellow ) {
            expandedBellow.style.display = 'none';
        }
    }

    let filteredCareers = [];
    if ( selectedTerm ) {
        filteredCareers = careers.filter( career => {
            return career.locations.filter( location => location.term_id === selectedTerm ).length;
        });
    } else {
        filteredCareers = careers;
    }

    const handleExpandedBellowChange = (e, id) => {
        if ( id !== expandedBellow ) {
            setExpandedBellow( id );

            // Collapse other accordions
            const expandedBellow = $('.careers-list .block-bellow--expanded .block-bellow__collapsable');
            if ( null !== expandedBellow ) {
                expandedBellow.slideUp(400)
            }
        } else {
            setExpandedBellow( false );
        }

        $( e.target ).parents('.block-bellow').find('.block-bellow__collapsable').slideToggle(400);
    }
    
    return (
        <div className="careers-list">
            <div className="careers-list__filters">
                <div className="container">
                    <ReactSelect
                        className="pfa-filter-select"
                        classNamePrefix="pfa-filter-select"
                        options={ options }
                        onChange={ handleOnFilterChange }
                        defaultValue={ options[0] }
                    />
                </div>
            </div>

            <div className="careers-list__careers">
                {filteredCareers.map(career => <Bellow career={ career } key={ career.ID } expandedBellow={ expandedBellow } handleExpandedBellowChange={ handleExpandedBellowChange } /> )}
            </div>
        </div>
    )
}

const element = document.getElementById('careers-list');
if ( null !== element && careersListData ) {
    const root = createRoot( element )
    root.render( <CareersList { ...careersListData } /> );
}